"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return React.createElement("input", { name: "__RequestVerificationToken", type: "hidden", value: _cookie2.default.getCookie('XSRF-TOKEN') });
};

var _cookie = require("linksoft/utils/cookie");

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/AntiForgeryToken.js
// module id = 1013
// module chunks = 0